// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".gacha-register-table {\n  margin-top: 10px;\n}\n\n.gacha-register-table-option {\n  width: 100%;\n  display: 'flex';\n  justify-content: flex-end;\n}\n\n.os-select .os-select-el {\n  display: block;\n  height: 30px;\n}\n", ""]);
// Exports
module.exports = exports;
